(function() {

const USE_GREEN_MARK = true;
const SPIXN_BASE_COLOR = '#4A2D57'; // 元のもの: #6C30CF
const SPIXN_GREEN = '#158E7A';
const SPIXN_GREEN2 = '#31727A';
const SPIXN_GREEN3 = '#02968A';
const SPIXN_GREEN_FOR_MARK = '#17A089';
const SPIXN_GREEN_FOR_CHECK = '#1AB298';
const SPIXN_LIGHT_GREEN = '#E8F7F5';
const SPIXN_BUTTON_ACTIVE_BACKGROUND = 'linear-gradient(73deg,rgba(2, 188, 172, 1) 0%, rgba(75, 73, 101, 1) 100%)';
const SPIXN_BUTTON_INACTIVE_BACKGROUND = 'white';
const SPIXN_BUTTON_ACTIVE_COLOR = 'white';
const SPIXN_BUTTON_INACTIVE_COLOR = SPIXN_GREEN;
const BUYBACK_DETAIL_LINK_ID = '__spixn_buyback_detail_link__';
const BUYBACK_SELECTION_AREA_BACKGROUND_COLOR = '#E6F8F7';
const BUYBACK_SELECTION_BUTTON_ID = '__spixn_buyback_selection_button__';
const BUYBACK_SELECTION_MARK_ID = '__spixn_buyback_selection_mark__';
const REGULAR_SELECTION_BUTTON_ID = '__spixn_regular_selection_button__';
const REGULAR_SELECTION_MARK_ID = '__spixn_regular_selection_mark__';
const BUY_IT_NOW_NOTICE_ID = '__spixn_buy_it_now_notice__';

// DAWN
// const SPIXN_BASE_FONT_SIZE = 24.8; // カスタムベースフォントサイズ（通常16pxより大きく設定）
const SPIXN_BASE_FONT_SIZE = 26; // カスタムベースフォントサイズ（通常16pxより大きく設定）
const BASE_FONT_FAMILY = '"Libre Baskerville", serif';
const PRODUCT_INPUT_SELECTOR = '.product-template .product__form-container .product__form-wrapper form input[name="product-id"]';
const VARIANT_INPUT_SELECTOR = '.product-template .product__form-container .product__form-wrapper form select[name="id"]';
const CURRENT_PRICE_SELECTOR = '.product__price .product__current-price';
const PRODUCT_NOTIFICATION_SELECTOR = 'p.product__notification';
// const ALTERNATIVE_VARIANT_INPUT_SELECTOR = '.featured-product--root product-buy-buttons-root select[name="id"]';

// BEYOND
// const SPIXN_BASE_FONT_SIZE = 16; // カスタムベースフォントサイズ（通常16pxより大きく設定）
// const BASE_FONT_FAMILY = 'inherit';

const BUYBACK_MODAL_SHOW_PRICE_RANGE = false; // true: 価格帯を表示する, false: 価格帯を表示しない
const SHOW_BUYBACK_PRICE_AS_PERCENTAGE = false; // true: バイバック保証額を販売額の%で表示, false: バイバック保証額をそのまま表示
// const DOWN_ORIGINAL_ADD_TO_CART_BUTTON_SELECTOR = "button.product-form__submit, button[name='add']";
// const BEYOND_ORIGINAL_ADD_TO_CART_BUTTON_SELECTOR = "product-buy-buttons-element > .product-buy-buttons--primary";
// const BEYOND_ORIGINAL_ADD_TO_CART_BUTTON_SELECTOR_OLD = '.product-page--root product-buy-buttons-root button.product-buy-buttons--cta';
const ORIGINAL_ADD_TO_CART_BUTTON_SELECTOR = '.product-template .product__form-container .product__form-wrapper form button.product__add-to-cart-button';
// const ALTERNATIVE_ADD_TO_CART_BUTTON_SELECTOR = '.featured-product--root product-buy-buttons-root button.product-buy-buttons--cta';
const PAY_CONTAINER_SELECTOR = '.product-template .product__form-container .product__form-wrapper form div.shopify-payment-button';

// '.product-page--root product-buy-buttons-root .product-buy-buttons--smart';


// --- 設定値（初期化時に変更可能） ---
let CART_DISPLAY_MODE = 'drawer'; // debug: デバッグ用（リダイレクトなし）, drawer: ドロワー表示, redirect: カートページリダイレクト

let DEBUG_MODE = true; // true: デバッグモード, false: 通常モード（本番環境ではfalse）
let log = DEBUG_MODE
	? console.log
	: () => {
			/* no-op */
		};

const BUYBACK_TOGGLE_BUTTON_INACTIVE_FONT_COLOR = '#26202C'; // default black
const FONT_SIZE_RATIO = SPIXN_BASE_FONT_SIZE / 16;

// ヘルパー関数：rem値をスケールされたcalc()に変換
function calcSize(size, option) {
	return `calc(${size} * ${FONT_SIZE_RATIO}${option ? option : ''})`;
}

// === 価格計算用定数 ===
const FALLBACK_PRICE_PERCENTAGE_DECREASE = 0.85; // フォールバック価格の減少率（15%減）
const FALLBACK_PRICE_PERCENTAGE_INCREASE = 1.15; // フォールバック価格の増加率（15%増）

// === API関連の設定と関数 ===
// API Base URL: initialize関数の引数で設定可能（dev/staging/prod）
let API_BASE_URL = 'https://ieyxoq7t4c.execute-api.ap-northeast-1.amazonaws.com/dev';
const API_TIMEOUT = 10000; // 10秒
const DEFAULT_HEADERS = {
	'Content-Type': 'application/json',
	'Accept': 'application/json'
};

// SPIXN API設定オブジェクト
const SPIXN_CONFIG = {
	USE_API: true,                    // API使用フラグ
	ENABLE_CACHE: true,               // キャッシュ使用フラグ
	FALLBACK_TO_LOCAL: false,         // ローカルデータフォールバック（常にfalse）
	DEBUG_MODE: false,                // デバッグモード
	API_TIMEOUT: 10000,               // APIタイムアウト（ミリ秒）
	CACHE_TTL: 5 * 60 * 1000,        // キャッシュTTL（5分）
	MAX_RETRIES: 3,                   // 最大リトライ回数
	RETRY_DELAY: 1000,                // リトライ遅延（ミリ秒）
	BATCH_SIZE: 10                    // バッチ処理サイズ
};

// Shop ID管理用のグローバル変数
let SHOP_ID = null;

/**
 * API Base URLを取得
 * @returns {string} API Base URL
 */
function getApiBaseUrl() {
	return API_BASE_URL;
}

/**
 * API Base URLを設定
 * @param {string} baseUrl - API Base URL
 */
function setApiBaseUrl(baseUrl) {
	if (baseUrl && typeof baseUrl === 'string') {
		API_BASE_URL = baseUrl;
		log('[SPIXN] API Base URL set:', baseUrl);
	}
}

/**
 * Shop IDを取得
 * @returns {string|null} Shop ID
 */
function getShopId() { 
	return SHOP_ID; 
}

/**
 * Shop IDを設定
 * @param {string} shopId - Shop ID
 */
function setShopId(shopId) { 
	SHOP_ID = shopId; 
}

/**
 * Shop IDの形式を検証
 * @param {string} shopId - Shop ID
 * @returns {boolean} 検証結果
 */
function validateShopId(shopId) {
	if (!shopId || typeof shopId !== 'string') {
		return false;
	}
	
	// .myshopify.com形式のチェック
	const shopifyDomainPattern = /^[a-zA-Z0-9\-]+\.myshopify\.com$/;
	return shopifyDomainPattern.test(shopId);
}

/**
 * 共通API呼び出し関数
 * @param {string} endpoint - APIエンドポイント
 * @param {Object} params - クエリパラメータ
 * @param {Object} options - 追加オプション
 * @returns {Promise<Object>} APIレスポンス
 */
async function callSpixnAPI(endpoint, params = {}, options = {}) {
	const controller = new AbortController();
	const timeoutId = setTimeout(() => controller.abort(), API_TIMEOUT);

	try {
		const url = new URL(`${API_BASE_URL}${endpoint}`);
		
		// パラメータをクエリストリングに追加
		Object.keys(params).forEach(key => {
			if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
				url.searchParams.append(key, params[key]);
			}
		});

		log('[SPIXN] API call:', url.toString());

		const response = await fetch(url.toString(), {
			method: 'GET',
			headers: {
				...DEFAULT_HEADERS,
				...options.headers
			},
			signal: controller.signal
		});

		clearTimeout(timeoutId);

		if (!response.ok) {
			throw new Error(`API call failed: ${response.status} ${response.statusText}`);
		}

		const data = await response.json();
		log('[SPIXN] API response:', data);
		
		return data;
	} catch (error) {
		clearTimeout(timeoutId);
		
		if (error.name === 'AbortError') {
			throw new Error('API call timeout');
		}
		
		console.error('[SPIXN] API call error:', error);
		throw error;
	}
}

/**
 * リトライ可能なエラーかどうかを判定
 * @param {Error} error - エラーオブジェクト
 * @returns {boolean} リトライ可能かどうか
 */
function isRetryableError(error) {
	// ネットワークエラーやタイムアウトはリトライ可能
	if (error.name === 'AbortError' || error.message.includes('timeout')) {
		return true;
	}
	
	// 5xx系エラーはリトライ可能
	if (error.message.includes('50')) {
		return true;
	}
	
	// 4xx系エラーはリトライしない
	return false;
}

/**
 * リトライ機能付きAPI呼び出し関数
 * @param {string} endpoint - APIエンドポイント
 * @param {Object} params - クエリパラメータ
 * @param {Object} options - 追加オプション
 * @returns {Promise<Object>} APIレスポンス
 */
async function callSpixnAPIWithRetry(endpoint, params = {}, options = {}) {
	const maxRetries = options.maxRetries || SPIXN_CONFIG.MAX_RETRIES;
	const retryDelay = options.retryDelay || SPIXN_CONFIG.RETRY_DELAY;

	for (let attempt = 1; attempt <= maxRetries; attempt++) {
		try {
			return await callSpixnAPI(endpoint, params, options);
		} catch (error) {
			if (attempt === maxRetries) {
				throw error;
			}

			// リトライ可能なエラーかチェック
			if (isRetryableError(error)) {
				log(`[SPIXN] API call failed (attempt ${attempt}/${maxRetries}), retrying...`);
				await new Promise(resolve => setTimeout(resolve, retryDelay * attempt));
			} else {
				throw error;
			}
		}
	}
}

/**
 * 数値IDをShopify GID形式に変換
 * @param {string|number} id - 数値ID
 * @param {string} type - リソースタイプ（'Product' または 'ProductVariant'）
 * @returns {string} GID形式のID
 */
function convertToShopifyGID(id, type) {
	if (!id) return null;
	const numericId = id.toString();
	return `gid://shopify/${type}/${numericId}`;
}

/**
 * Shopify GIDから数値IDを抽出
 * @param {string} gid - GID形式のID
 * @returns {string|null} 数値ID
 */
function extractNumericIdFromGID(gid) {
	if (!gid || typeof gid !== 'string') return null;
	const match = gid.match(/gid:\/\/shopify\/\w+\/(\d+)/);
	return match ? match[1] : null;
}

/**
 * 現在の商品IDを取得（GID形式で返す）
 * @returns {string|null} 商品ID（GID形式）
 */
function getCurrentProductId() {
	try {

		const productIdInput = document.querySelector(PRODUCT_INPUT_SELECTOR);
		if (productIdInput?.value) {
			return convertToShopifyGID(productIdInput.value, 'Product');
		}





		// 方法1: ShopifyAnalyticsから取得
		const productData = window.ShopifyAnalytics?.meta?.product;
		if (productData?.id) {
			const numericId = productData.id.toString();
			return convertToShopifyGID(numericId, 'Product');
		}

		// 方法2: フォームのhidden inputから取得
		const productIdInput2 = document.querySelector('input[name="product-id"]');
		if (productIdInput2?.value) {
			return convertToShopifyGID(productIdInput2.value, 'Product');
		}

		// 方法3: data属性から取得
		const productElement = document.querySelector('[data-product-id]');
		if (productElement) {
			const productId = productElement.getAttribute('data-product-id');
			if (productId) {
				return convertToShopifyGID(productId, 'Product');
			}
		}

		// 方法4: URLから商品ハンドルを取得（最後の手段）
		const pathMatch = window.location.pathname.match(/\/products\/([^\/]+)/);
		if (pathMatch) {
			const handle = pathMatch[1];
			// ハンドルから商品IDを取得する処理が必要
			// この部分は環境に依存するため、実装時に調整が必要
			console.warn('[SPIXN] Product ID not found, handle detected:', handle);
		}

		console.error('[SPIXN] Product ID not found');
		return null;
	} catch (error) {
		console.error('[SPIXN] Failed to get product ID:', error);
		return null;
	}
}

/**
 * APIレスポンスを既存形式に変換
 * @param {Object} buybackData - APIレスポンスデータ
 * @returns {Object} 変換されたバイバック情報
 */
function transformBuybackData(buybackData) {
	return {
		buyback_variant_id: parseInt(buybackData.buyback_sp_variant_id),
		insurance_period_days: buybackData.insurance_period_days,
		insurance_fee: buybackData?.insurance_fee || 0,
		// 現在は単一の'default'プランのみをサポート
		// 将来的に複数プランをサポートする場合は、この配列構造を拡張する
		plans: [{
			plan: 'default',
			insurance_period_days: buybackData.insurance_period_days,
			a_price: buybackData.a_price,
			b_price: buybackData.b_price,
			c_price: buybackData.c_price,
			a_min_price: buybackData.a_min_price || Math.round(buybackData.a_price * FALLBACK_PRICE_PERCENTAGE_DECREASE),
			a_max_price: buybackData.a_max_price || Math.round(buybackData.a_price * FALLBACK_PRICE_PERCENTAGE_INCREASE),
			b_min_price: buybackData.b_min_price || Math.round(buybackData.b_price * FALLBACK_PRICE_PERCENTAGE_DECREASE),
			b_max_price: buybackData.b_max_price || Math.round(buybackData.b_price * FALLBACK_PRICE_PERCENTAGE_INCREASE),
			c_min_price: buybackData.c_min_price || Math.round(buybackData.c_price * FALLBACK_PRICE_PERCENTAGE_DECREASE),
			c_max_price: buybackData.c_max_price || Math.round(buybackData.c_price * FALLBACK_PRICE_PERCENTAGE_INCREASE),
			a_price_ratio: buybackData.a_price_ratio,
			b_price_ratio: buybackData.b_price_ratio,
			c_price_ratio: buybackData.c_price_ratio,
			a_min_price_ratio: buybackData.a_min_price_ratio || buybackData.a_price_ratio * FALLBACK_PRICE_PERCENTAGE_DECREASE,
			a_max_price_ratio: buybackData.a_max_price_ratio || buybackData.a_price_ratio * FALLBACK_PRICE_PERCENTAGE_INCREASE,
			b_min_price_ratio: buybackData.b_min_price_ratio || buybackData.b_price_ratio * FALLBACK_PRICE_PERCENTAGE_DECREASE,
			b_max_price_ratio: buybackData.b_max_price_ratio || buybackData.b_price_ratio * FALLBACK_PRICE_PERCENTAGE_INCREASE,
			c_min_price_ratio: buybackData.c_min_price_ratio || buybackData.c_price_ratio * FALLBACK_PRICE_PERCENTAGE_DECREASE,
			c_max_price_ratio: buybackData.c_max_price_ratio || buybackData.c_price_ratio * FALLBACK_PRICE_PERCENTAGE_INCREASE
		}]
	};
}

/**
 * バイバックデータの検証
 * @param {Object} data - 検証対象データ
 * @returns {boolean} 検証結果
 */
function validateBuybackData(data) {
	const requiredFields = [
		'sp_shop_id',
		'sp_product_id',
		'sp_variant_id',
		'buyback_sp_variant_id',
		'insurance_fee',
		'insurance_period_days',
		'a_price',
		'b_price',
		'c_price',
		'a_price_ratio',
		'b_price_ratio',
		'c_price_ratio'
	];

	for (const field of requiredFields) {
		if (data[field] === null || data[field] === undefined) {
			console.error(`[SPIXN] Missing required field: ${field}`);
			return false;
		}
	}

	// 数値フィールドの検証
	const numericFields = [
		'insurance_fee',
		'insurance_period_days',
		'a_price',
		'b_price',
		'c_price',
		'a_price_ratio',
		'b_price_ratio',
		'c_price_ratio'
	];

	for (const field of numericFields) {
		if (typeof data[field] !== 'number' || data[field] < 0) {
			console.error(`[SPIXN] Invalid numeric field: ${field} = ${data[field]}`);
			return false;
		}
	}

	return true;
}

/**
 * バイバック情報を取得（API版）
 * @param {number|string} variantId - バリアントID
 * @returns {Promise<Object|null>} バイバック情報
 */
async function getBuybackInformation(variantId) {
	try {
		// Shop IDチェック（セットされていなければ何もしない）
		const shopId = getShopId();
		if (!shopId) {
			console.log('[SPIXN] Shop ID not set, skipping buyback information retrieval');
			return null;
		}

		const productId = getCurrentProductId();
		if (!productId) {
			throw new Error('Product ID not available');
		}

		// APIパラメータを構築
		const params = {
			sp_shop_id: shopId,
			// sp_product_id: productId.toString()
		};

		// バリアントIDが指定されている場合は追加（GID形式に変換）
		if (variantId) {
			params.sp_variant_id = convertToShopifyGID(variantId, 'ProductVariant');
		}

		// API呼び出しログを出力
		log('[SPIXN] API call for variant:', variantId, 'with params:', params);

		// API呼び出し
		const response = await callSpixnAPIWithRetry('/shopify/buyback', params);

		// レスポンス検証
		if (!response.data || !Array.isArray(response.data) || response.data.length === 0) {
			log('[SPIXN] No buyback information found for variant:', variantId);
			return null;
		}

		const buybackData = response.data[0];
		
		// データ検証
		if (!validateBuybackData(buybackData)) {
			throw new Error('Invalid buyback data received from API');
		}

		// 既存の形式に変換
		const transformedData = transformBuybackData(buybackData);
		log('[SPIXN] Successfully retrieved and transformed buyback data for variant:', variantId, transformedData);
		
		return transformedData;
	} catch (error) {
		console.error('[SPIXN] Failed to get buyback information:', error);
		return null;
	}
}

// === 既存のUI関連変数とフラグ ===
let isModalVisible = false;
let buybackToggleEnabled = true;
let modalStylesAdded = false;
let spixnFeaturesDisabled = false; // 無限ループ防止フラグ

function toggleAcceleratedCheckoutBlock(isBuybackEnabled) {
	const payContainer = document.querySelector(PAY_CONTAINER_SELECTOR);
	if (!payContainer) return;
	
	payContainer.style.position = 'relative'; // 確実に relative にする

	// 既に付いているブロッカーを消す
	const existing = payContainer.querySelector('.spixn-pay-blocker');
	if (existing) existing.remove();

	// モード ON のときだけ blocker を追加
	if (isBuybackEnabled) {
		const blocker = document.createElement('div');
		Object.assign(blocker.style, {
			position: "absolute",
			top: 0,
			left: 0,
			width: "100%",
			height: "100%",
			background: "rgba(255,255,255,0.5)",
			zIndex: 50,
			display: "block",
		});

		blocker.className = 'spixn-pay-blocker';
		payContainer.appendChild(blocker);
		
		log('Accelerated checkout block enabled', blocker, payContainer);
	}
}

// ダイアログ内のpタグのmarginを0にするスタイルを追加
function addModalStyles() {
	if (modalStylesAdded) return;
	
	const style = document.createElement('style');
	style.textContent = `
		#spixn-buyback-modal p {
			margin: 0;
		}
		#spixn-buyback-modal button {
		   font-family: ${BASE_FONT_FAMILY};
        }
	`;
	document.head.appendChild(style);
	modalStylesAdded = true;
}

/**
 * SPIXN API機能の初期化
 * @param {string} shopId - Shop ID
 */
async function initializeSpixnAPI(shopId) {
	try {
		log('[SPIXN] Initializing SPIXN API...');
		
		// Shop IDを設定
		if (shopId && validateShopId(shopId)) {
			setShopId(shopId);
			log('[SPIXN] Shop ID set:', shopId);
			log('[SPIXN] SPIXN API initialization completed');
			return true;
		} else {
			console.warn('[SPIXN] Shop ID not available or invalid:', shopId);
			return false;
		}
	} catch (error) {
		console.error('[SPIXN] SPIXN API initialization failed:', error);
		return false;
	}
}

/**
 * 簡易debounce実装
 * @param {Function} func - 実行する関数
 * @param {number} wait - 待機時間（ミリ秒）
 * @returns {Function} debounceされた関数
 */
function debounce(func, wait) {
	let timeout;
	return function(...args) {
		clearTimeout(timeout);
		timeout = setTimeout(() => func.apply(this, args), wait);
	};
}

/**
 * 初期化処理（外部から呼び出し用）
 * @param {string} shopId - Shop ID
 * @param {string} [apiBaseUrl] - API Base URL（オプション）
 * @param {Object} [options] - 設定オプション
 * @param {boolean} [options.debugMode] - デバッグモード（デフォルト: false）
 * @param {string} [options.cartDisplayMode] - カート表示モード（'debug', 'drawer', 'redirect'）
 */
async function initialize(shopId, apiBaseUrl, options = {}) {
	console.log('🚀 [SPIXN] Initializing Shopify Product Buyback Display v4.3');
	console.log('🔍 [SPIXN] Parameters:', { shopId, apiBaseUrl, options });
	
	// zenlink要素の存在チェック（初期化を停止する条件）
	if (checkZenlinkElement()) {
		console.log('🛑 [SPIXN] zenlink element detected, skipping initialization');
		return;
	}
	
	// DEBUG_MODEの設定
	if (typeof options.debugMode !== 'undefined') {
		DEBUG_MODE = options.debugMode;
		log = DEBUG_MODE ? console.log : () => {};
	}
	
	// CART_DISPLAY_MODEの設定
	if (options.cartDisplayMode) {
		CART_DISPLAY_MODE = options.cartDisplayMode;
	}
	
	console.log('⚙️ [SPIXN] Configuration:', { debugMode: DEBUG_MODE, cartDisplayMode: CART_DISPLAY_MODE });
	
	// API Base URLが指定されている場合は設定
	if (apiBaseUrl) {
		setApiBaseUrl(apiBaseUrl);
		console.log('🌐 [SPIXN] API Base URL set:', apiBaseUrl);
	}
	
	// Shop IDの詳細チェック
	console.log('🏪 [SPIXN] Shop ID validation:', {
		provided: shopId,
		type: typeof shopId,
		valid: validateShopId(shopId),
		windowShopify: window.Shopify?.shop
	});
	
	// API初期化を先に実行
	console.log('🔧 [SPIXN] Starting API initialization...');
	const apiInitialized = await initializeSpixnAPI(shopId);
	
	if (!apiInitialized) {
		console.warn('❌ [SPIXN] API initialization failed, skipping setup');
		return;
	}
	
	console.log('✅ [SPIXN] API initialization successful, proceeding with setup');
	
	// バイバック統合をセットアップ
	console.log('🏗️ [SPIXN] Setting up buyback integration...');
	await setupBuybackIntegration();
	
	// バリエーション変更を監視（MutationObserverを使用）
	console.log('👀 [SPIXN] Setting up variant change observer...');
	setupVariantChangeObserver();
	
	// zenlink要素の動的監視を開始
	console.log('👁️ [SPIXN] Setting up zenlink monitoring...');
	setupZenlinkObserver();
	
	console.log('🎉 [SPIXN] Initialization complete!');
}



async function setupBuybackIntegration() {
	log('setupBuybackIntegration');
	
	const currentVariantId = getCurrentVariantId();
	if (!currentVariantId) {
		log('Current variant ID not found');
		return;
	}

	log('Fetching buyback information for variant:', currentVariantId);
	const buybackInfo = await getBuybackInformation(currentVariantId);
	if (!buybackInfo) {
		log('No buyback information found for variant:', currentVariantId);
		return;
	}
	log('Buyback information found:', buybackInfo);

	// 既存のボタンを取得
	const originalButton = document.querySelector(ORIGINAL_ADD_TO_CART_BUTTON_SELECTOR) || document.querySelector(ALTERNATIVE_ADD_TO_CART_BUTTON_SELECTOR);
	if (!originalButton) {
		log('Original submit button not found');
		return;
	}

	// バイバック保証UIを設置
	setupBuybackUI(buybackInfo, originalButton);
	
	// 既存ボタンの動作を変更
	modifyOriginalButton(originalButton, buybackInfo);
}

/**
 * 既存のバイバックUIを削除（安全版）
 */
function removeBuybackUI() {
	console.log('🗑️ [SPIXN] Starting safe buyback UI removal');

	// トグルボタンを削除
	if (window.buybackToggle) {
		console.log('🗑️ [SPIXN] Removing toggle button');
		window.buybackToggle.remove();
		window.buybackToggle = null;
	}

	// マークを削除
	if (window.buybackMark) {
		console.log('🗑️ [SPIXN] Removing mark');
		window.buybackMark = null;
	}

	// Buy it now説明を削除
	const buyItNowNotice = document.querySelector(`#${BUY_IT_NOW_NOTICE_ID}`);
	if (buyItNowNotice) {
		console.log('🗑️ [SPIXN] Removing buy it now notice');
		buyItNowNotice.remove();
	}

	// Accelerated checkout blockを削除
	const payBlocker = document.querySelector('.spixn-pay-blocker');
	if (payBlocker) {
		console.log('🗑️ [SPIXN] Removing pay blocker');
		payBlocker.remove();
	}

	// powered by表記を安全に削除（特定のクラス名で識別）
	// const poweredByElements = document.querySelectorAll('.spixn-powered-by');
	// poweredByElements.forEach(el => {
	// 	console.log('🗑️ [SPIXN] Removing powered by element');
	// 	el.remove();
	// });

	// 詳細リンクコンテナを安全に削除（特定のクラス名で識別）
	// const linkContainers = document.querySelectorAll('.spixn-detail-link-container');
	// linkContainers.forEach(el => {
	// 	console.log('🗑️ [SPIXN] Removing detail link container');
	// 	el.remove();
	// });

	// バイバック保証ボタンを削除
	var buybackButton = document.getElementById(BUYBACK_SELECTION_BUTTON_ID);
	if (buybackButton) {
		console.log('🗑️ [SPIXN] Removing buyback selection button');
		buybackButton.remove();
	}
	
	// 通常購入ボタンを削除
	var regularButton = document.getElementById(REGULAR_SELECTION_BUTTON_ID);
	if (regularButton) {
		console.log('🗑️ [SPIXN] Removing regular selection button');
		regularButton.remove();
	}

	console.log('✅ [SPIXN] Safe buyback UI removal completed');
}

/**
 * バイバックUIを非表示にする
 */
function hideBuybackUI() {
	removeBuybackUI();
	log('Buyback UI hidden (no buyback info available)');
}

/**
 * 既存ボタンのイベントリスナーをリセット
 */
function resetOriginalButtonEvents(originalButton) {
	// 既存のイベントリスナーを削除するため、ボタンを複製して置き換える
	const newButton = originalButton.cloneNode(true);
	originalButton.parentNode.replaceChild(newButton, originalButton);
	return newButton;
}

async function updateBuybackUIForVariant() {
	console.log('🔄 [SPIXN] updateBuybackUIForVariant started');
	
	const currentVariantId = getCurrentVariantId();
	console.log('🔍 [SPIXN] Current variant ID:', currentVariantId);
	
	if (!currentVariantId) {
		console.log('❌ [SPIXN] Current variant ID not found for update');
		// バリアントIDが取得できない場合、既存のUIを非表示にする
		hideBuybackUI();
		return;
	}

	console.log('🌐 [SPIXN] Fetching buyback information for variant:', currentVariantId);
	const buybackInfo = await getBuybackInformation(currentVariantId);
	
	if (!buybackInfo) {
		console.log('❌ [SPIXN] No buyback information found for variant:', currentVariantId);
		// バリエーションにbuyback情報がない場合、UIを非表示にする
		hideBuybackUI();
		return;
	}

	console.log('✅ [SPIXN] Buyback information found:', buybackInfo);

	// 既存のバイバックUIを削除
	console.log('🗑️ [SPIXN] Removing existing buyback UI');
	removeBuybackUI();
	
	// DOM更新完了を待ってからボタンを検索
	console.log('⏳ [SPIXN] Waiting for DOM update completion...');
	
	// 複数回試行してボタンを検索
	let originalButton = null;
	let attempts = 0;
	const maxAttempts = 10;
	const delay = 50; // 50ms間隔
	
	const findButton = () => {
		originalButton = document.querySelector(ORIGINAL_ADD_TO_CART_BUTTON_SELECTOR) || document.querySelector(ALTERNATIVE_ADD_TO_CART_BUTTON_SELECTOR);
		attempts++;
		
		console.log(`🔍 [SPIXN] Button search attempt ${attempts}/${maxAttempts}: ${!!originalButton}`);
		
		if (originalButton) {
			console.log('✅ [SPIXN] Original button found after', attempts * delay, 'ms');
			setupButtonAndUI();
		} else if (attempts < maxAttempts) {
			setTimeout(findButton, delay);
		} else {
			console.log('❌ [SPIXN] Original submit button not found after', maxAttempts * delay, 'ms');
			return;
		}
	};
	
	const setupButtonAndUI = () => {
		// 既存ボタンのイベントリスナーをリセット
		console.log('🔄 [SPIXN] Resetting original button events');
		originalButton = resetOriginalButtonEvents(originalButton);

		// バイバック保証UIを再構築
		console.log('🏗️ [SPIXN] Setting up buyback UI');
		setupBuybackUI(buybackInfo, originalButton);
		
		// 既存ボタンの動作を再設定
		console.log('🔧 [SPIXN] Modifying original button');
		modifyOriginalButton(originalButton, buybackInfo);
		
		// トグル状態をリセット（新しいバリアントでは初期状態に戻す）
		console.log('🔄 [SPIXN] Resetting toggle state');
		// buybackToggleEnabled = false;
		updateToggleButtonState(window.buybackToggle, buybackToggleEnabled);
		toggleAcceleratedCheckoutBlock(buybackToggleEnabled);
		
		console.log('✅ [SPIXN] Buyback UI completely updated for variant:', currentVariantId);
	};
	
	// ボタン検索を開始
	findButton();
}

function setupVariantChangeObserver() {
	console.log('🔍 [SPIXN] Setting up variant change observer');
	
	// const variantInput = document.querySelector('input[name="id"]');
	const variantInputSelector = VARIANT_INPUT_SELECTOR;
	const variantInput = document.querySelector(variantInputSelector) || document.querySelector(ALTERNATIVE_VARIANT_INPUT_SELECTOR);
	console.log('🔍 [SPIXN] Variant input found:', !!variantInput, variantInputSelector);
	
	if (!variantInput) {
		console.log('❌ [SPIXN] Variant input not found for observer');
		return;
	}

	let lastVariantId = variantInput.value;
	console.log('🔍 [SPIXN] Initial variant ID for observer:', lastVariantId);

	// メイン: input要素のchangeイベントを監視
	// variantInput.addEventListener('change', function() {
	// 	console.log('🔔 [SPIXN] Variant input change event fired');
	// 	const currentVariantId = variantInput.value;
	// 	console.log('🔄 [SPIXN] Variant input change detected:', lastVariantId, '->', currentVariantId);
		
	// 	if (currentVariantId !== lastVariantId) {
	// 		console.log('✅ [SPIXN] Variant actually changed, updating UI');
	// 		lastVariantId = currentVariantId;
	// 		updateBuybackUIForVariant();
	// 	} else {
	// 		console.log('⚠️ [SPIXN] Variant change event fired but value unchanged');
	// 	}
	// });

	let lastValue = variantInput.value;

	setInterval(() => {
		if (variantInput.value !== lastValue) {
			console.log('🔔 [SPIXN] Variant input value change detected via polling:', lastValue, '->', variantInput.value);
			lastValue = variantInput.value;
			updateBuybackUIForVariant();
		}

	}, 500);
	// variantInput.onChange = function() {
	// 	console.log('🔔 [SPIXN] Variant input onChange event fired');
	// 	const currentVariantId = variantInput.value;
	// 	console.log('🔄 [SPIXN] Variant input onChange detected:', lastVariantId, '->', currentVariantId);
	// }

	// 追加: input要素の値変更を直接監視（MutationObserver）
	// const observer = new MutationObserver(function(mutations) {
	// 	mutations.forEach(function(mutation) {
	// 		console.log('🔔 [SPIXN] MutationObserver mutation detected:', mutation);
	// 		if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
	// 			const currentVariantId = variantInput.value;
	// 			console.log('🔄 [SPIXN] Variant input value attribute changed:', lastVariantId, '->', currentVariantId);
				
	// 			if (currentVariantId !== lastVariantId) {
	// 				console.log('✅ [SPIXN] Variant changed via attribute mutation, updating UI');
	// 				lastVariantId = currentVariantId;
	// 				updateBuybackUIForVariant();
	// 			}
	// 		}
	// 	});
	// });
	
	// observer.observe(variantInput, {
	// 	attributes: true,
	// 	attributeFilter: ['value']
	// });

	console.log('✅ [SPIXN] Variant change observer setup complete (change event + mutation observer)');
}

function getCurrentVariantId() {
	const variantInput = document.querySelector(VARIANT_INPUT_SELECTOR) || document.querySelector(ALTERNATIVE_VARIANT_INPUT_SELECTOR);
	return variantInput ? parseInt(variantInput.value, 10) : null;
}

function getCurrentQuantity() {
	const quantityInput = document.querySelector('input[name="quantity"]');
	return quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
}

function getCurrentPrice() {
	return parseInt(document.querySelector(CURRENT_PRICE_SELECTOR)?.textContent.trim().replaceAll(/\D/g, ''))

}

function setupBuybackUI(buybackInfo, originalButton) {
	log('setupBuybackUI', buybackInfo, originalButton);
	const plan = buybackInfo.plans[0];
	const maxPriceNum = plan.a_price;
	const maxPrice = maxPriceNum.toLocaleString();
	const maxPricePercentage = Math.round(plan.a_price_ratio * 100);
	const currentPrice = getCurrentPrice();
	log('Current price:', currentPrice);

	// // powered by表記
	// const poweredBy = document.createElement('a');
	// poweredBy.className = 'spixn-powered-by';
	// poweredBy.style.cssText = `
	// 	font-size: ${calcSize('0.8rem')};
	// 	display: flex;
	// 	gap: ${calcSize('0.2rem')};
	// 	align-items: center;
	// 	margin: ${calcSize('0.5rem')} 0;
	// 	text-decoration: none;
	// 	border: none;
	// 	background: none;
	// `;
	// poweredBy.href = 'https://user.spixn.co.jp';
	// poweredBy.target = '_blank';
	// poweredBy.innerHTML = `<small style='font-size:${calcSize('0.8rem')};color:#888;line-height: normal;'>
	// 	${createSpixnMarkCircleSVG(USE_GREEN_MARK)}
	// 	バイバック保証は <strong>spixn</strong> の提供するサービスです
	// </small>`;

	// バイバック保証詳細リンクを作成
	const detailLink = document.createElement('a');
	detailLink.id = BUYBACK_DETAIL_LINK_ID;
	detailLink.href = '#';
	detailLink.textContent = '品質ランク別バイバック保証額を確認する';
	detailLink.style.cssText = `
		font-size: ${calcSize('0.5rem')};
		display: block;
		color: #4A2D57;
		text-decoration: underline;
	`;
	detailLink.onclick = async (e) => {
		e.preventDefault();
		// ダイアログを開く時点で現在のバリエーションに基づいてbuyback情報を取得
		const currentVariantId = getCurrentVariantId();
		const currentBuybackInfo = await getBuybackInformation(currentVariantId);
		if (currentBuybackInfo) {
			showBuybackModal(currentBuybackInfo);
		} else {
			alert('選択された商品にはバイバック保証がありません');
		}
	};

	// トグルボタンを作成
	const toggleButton = document.createElement('button');
	toggleButton.type = 'button';
	toggleButton.textContent = `最大 ${SHOW_BUYBACK_PRICE_AS_PERCENTAGE ? `${maxPricePercentage}%` : `￥${maxPrice}`} のバイバック保証`;
	toggleButton.style.cssText = `
		padding: ${calcSize('0.1rem')} ${calcSize('0.1rem')};
		font-size: ${calcSize('0.8rem')};
		border: 1px solid ${SPIXN_GREEN};
		border-radius: 6px;
		cursor: pointer;
		background-color: white;
		color: ${BUYBACK_TOGGLE_BUTTON_INACTIVE_FONT_COLOR};
		margin: ${calcSize('0.5rem')} 0;
		display: block;
		width: 100%;
		font-family: ${BASE_FONT_FAMILY};
	`;
	
	toggleButton.onclick = () => {
		buybackToggleEnabled = !buybackToggleEnabled;
		updateToggleButtonState(toggleButton, buybackToggleEnabled);
		toggleAcceleratedCheckoutBlock(buybackToggleEnabled);
	};

	// Buy it now or Shop Pay button の下に説明を追加
	const descId = BUY_IT_NOW_NOTICE_ID;
	const existingDescription = document.querySelector(`#${descId}`);
	if (existingDescription) {
		existingDescription.remove();
	}
	const payContainer = document.querySelector(PAY_CONTAINER_SELECTOR);
	if (payContainer) {
		const desc = document.createElement('div');
		desc.id = descId;
		desc.style.cssText = `
			font-size: ${calcSize('0.8rem')};
			color: ${SPIXN_BASE_COLOR};
			margin-top: ${calcSize('0.5rem')};
		`;
		desc.innerHTML = `
		<div>
		バイバック保証をご利用の場合${originalButton.textContent}ボタンをお使いください。
		</div>
		<div>
		${createSpixnMarkCircleSVG(USE_GREEN_MARK)}
		バイバック保証は外部サービス「spixn」によって提供されています。
		保証を有効にするには、購入後に注文時と同じメールアドレスでspixnに会員登録してください。
		</div>
		<div style="text-align: center; margin-top: 29px;">
			<a href="/pages/spixn" target="_blank" style="color: ${SPIXN_BASE_COLOR}; text-decoration: underline;">
			バイバック保証について詳しくみる
			</a>
		</div>
		`;
		payContainer.after(desc);
	} else {
		log('[SPIXN] Pay container not found for buy it now notice');
	}

	// バイバック保証付き購入 セレクションエリア
	// const buybackAreaId = BUYBACK_SELECTION_BUTTON_ID
	const buybackButton = document.createElement('button');
	buybackButton.type = 'button';
	buybackButton.id = BUYBACK_SELECTION_BUTTON_ID;
	buybackButton.style.cssText = `
		border: 2px solid ${buybackToggleEnabled ? SPIXN_GREEN : "#E9E9EA"};
		border-radius: 6px;
		padding: ${calcSize('0.5rem')};
		margin: ${calcSize('0.5rem')} 0;
		background-color: ${buybackToggleEnabled ? BUYBACK_SELECTION_AREA_BACKGROUND_COLOR : "#fff"};
		height: auto;
		width: 100%;
		position: relative;
		line-height: normal;
		letter-spacing: normal;
		padding: 13px;
	`;
	buybackButton.onclick = () => {
		if(buybackToggleEnabled) return; // すでにONなら何もしない
		buybackToggleEnabled = true;
		updateToggleButtonState(toggleButton, buybackToggleEnabled);
		toggleAcceleratedCheckoutBlock(buybackToggleEnabled);
	};

	buybackButton.innerHTML = `
	    <div class="spixn-mark" style="position: absolute; top: -1px; right: -1px;">
		 ${createSpixnMarkInSquareSVG(buybackToggleEnabled)}
		</div>
	    <div style="display: flex ; align-items: center; gap: 15px;font-weight: 600; ">
			<div style="display: flex; gap: 4px; align-items: center; font-size: ${calcSize('0.7rem')}; color: ${SPIXN_BASE_COLOR}; white-space: nowrap;">
				<div id="${BUYBACK_SELECTION_MARK_ID}">${buybackToggleEnabled ? createCheckCircleHTML() : createGrayCircleHTML()}</div> バイバック保証付きで購入
			</div>
		</div>
		<div style="padding-left: 18px;display: flex; flex-direction: column; align-items: flex-start;">
			<div style="display: flex; justify-content: flex-start ; gap: 5px; align-items: flex-end; width: 100%;">
				<div style="font-size: ${calcSize('0.8rem')}; color: ${SPIXN_BASE_COLOR}; font-family: var(--font-accent-family);font-weight: 600; white-space: nowrap;">
					¥<span style="font-size: ${calcSize('1.4rem')}">${(currentPrice +  buybackInfo.insurance_fee).toLocaleString()}</span><span style="font-size: ${calcSize('0.5rem')};">(税込)</span>					
				</div>
				<div style="font-size: ${calcSize('0.4rem')};text-align: left; ">
					保証料は商品とは別に
					カゴへ自動追加されます
				</div>
			</div>
			<div style="display: flex;flex-direction: column;align-items: center;">
				<div style="font-size: ${calcSize('0.8rem')}; color: ${SPIXN_BASE_COLOR}; font-family: var(--font-accent-family);font-weight: 600; visibility: hidden; height: 0;">
					¥<span style="font-size: ${calcSize('1.4rem')}">${(currentPrice +  buybackInfo.insurance_fee).toLocaleString()}</span>
				</div>
				<div style="line-height: 0;margin: 5px 0;">${createDoubleDownArrowSVG()}</div>
			</div>
			<div style="font-size: ${calcSize('0.6rem')}; color: #F3004D;font-family: var(--font-accent-family);font-weight: 600;">
			¥<span style="font-size: ${calcSize('1.0rem')}">${ (currentPrice + buybackInfo.insurance_fee - plan.a_price).toLocaleString()}</span>
			〜
			¥<span style="font-size: ${calcSize('1.0rem')}">${ (currentPrice + buybackInfo.insurance_fee - plan.c_price).toLocaleString() }</span>
				実質負担額
			</div>
			<div style="display: flex ; gap: 15px; align-items: baseline;font-size: ${calcSize('0.5rem')}; font-weight: 600;">
				<div>
				商品ランクに応じて保証額をキャッシュバック
				</div>
				<div style="display: flex; align-items: baseline; white-space: nowrap;">
					保証期間
					<span style="font-size: ${calcSize('0.85rem')};">${buybackInfo.insurance_period_days / 365}</span>
					年
				</div>
			</div>
			<div id="detail-link-container" style="margin-top: 8px;">
			</div>
		</div>
	`;
	buybackButton.querySelector('#detail-link-container').appendChild(detailLink);



	// const regularAreaId = '__spixn_regular_selection_area__';
	const regularButton = document.createElement('button');
	regularButton.type = 'button';
	regularButton.id = REGULAR_SELECTION_BUTTON_ID;
	regularButton.style.cssText = `
		border: 2px solid ${buybackToggleEnabled ? "#E9E9EA" : SPIXN_GREEN};
		border-radius: 6px;
		padding: ${calcSize('0.5rem')};
		margin: ${calcSize('0.5rem')} 0;
		background-color: ${buybackToggleEnabled ?  "#fff": BUYBACK_SELECTION_AREA_BACKGROUND_COLOR};
		height: auto;
		width: 100%;
		position: relative;
		line-height: normal;
		letter-spacing: normal;
		padding: 13px;

	`;
	regularButton.onclick = () => {
		if(!buybackToggleEnabled) return; // すでにOFFなら何もしない
		buybackToggleEnabled = false;
		updateToggleButtonState(toggleButton, buybackToggleEnabled);
		toggleAcceleratedCheckoutBlock(buybackToggleEnabled);
	};


	regularButton.innerHTML = `
	    <div style="display: flex ; align-items: center; gap: 15px;">
			<div style="display: flex; gap: 4px; align-items: center; font-size: ${calcSize('0.7rem')}; font-weight: 600; color: ${SPIXN_BASE_COLOR}; margin-bottom: ${calcSize('0.25rem')};">
				<div id="${REGULAR_SELECTION_MARK_ID}">${buybackToggleEnabled ? createGrayCircleHTML() : createCheckCircleHTML() }</div> 通常購入
			</div>
		</div>
		<div style="padding-left: 30px;display: flex; flex-direction: column; align-items: flex-start;">
			<div style="font-size: ${calcSize('0.8rem')}; color: ${SPIXN_BASE_COLOR}; font-family: var(--font-accent-family);font-weight: 600">
				¥<span style="font-size: ${calcSize('1.4rem')}">${currentPrice.toLocaleString()}</span><span style="font-size: ${calcSize('0.5rem')};">(税込)</span>
				
			</div>
			<div style="justify-content: space-between; display: flex ; align-items: flex-end;font-size: ${calcSize('0.5rem')}; font-weight: 600;color: #939096;">
        		バイバック保証なし
			</div>
		</div>
	`;	


	// // マークを作成
	// const mark = document.createElement('div');
	// mark.innerHTML = createDashedCircleHTML();
	// mark.style.cssText = `display: inline-block; margin-right: ${calcSize('0.5rem')};`;

	// const chevron = document.createElement("div");
	// chevron.style.cssText = `display: flex; align-items: center;color: ${SPIXN_GREEN3};`;
	// chevron.innerHTML = createRightChevronSVG();

	// // 詳細リンクとマークのコンテナ
	// const linkContainer = document.createElement('div');
	// linkContainer.className = 'spixn-detail-link-container';
	// linkContainer.style.cssText = `
	// 	display: flex;
	// 	align-items: center;
	// 	margin: ${calcSize('0.5rem')} 0;
	// 	border: none;
	// 	background: none;
	// `;
	// linkContainer.appendChild(mark);
	// linkContainer.appendChild(detailLink);
	// linkContainer.appendChild(chevron);

	// 既存ボタンの前に挿入
	const buttonContainer = originalButton.parentElement;
	// buttonContainer.insertBefore(poweredBy, originalButton);
	// buttonContainer.insertBefore(linkContainer, originalButton);
	// buttonContainer.insertBefore(toggleButton, originalButton);
	buttonContainer.insertBefore(buybackButton, originalButton);
	buttonContainer.insertBefore(regularButton, originalButton);

	// グローバル参照用に保存
	// window.buybackMark = mark;
	window.buybackToggle = toggleButton;
	toggleAcceleratedCheckoutBlock(buybackToggleEnabled);
}

function updateToggleButtonState(toggleButton, enabled) {

	const buybackButton = document.getElementById(BUYBACK_SELECTION_BUTTON_ID);
	const regularButton = document.getElementById(REGULAR_SELECTION_BUTTON_ID);
	const buybackMark = document.getElementById(BUYBACK_SELECTION_MARK_ID);
	const regularMark = document.getElementById(REGULAR_SELECTION_MARK_ID);
	const buybackSpixnMark = buybackButton.querySelector('.spixn-mark');

	if (enabled) {
		// toggleButton.style.backgroundColor = SPIXN_BASE_COLOR;
		toggleButton.style.background = SPIXN_BUTTON_ACTIVE_BACKGROUND;
		toggleButton.style.border = 'none';
		toggleButton.style.color = SPIXN_BUTTON_ACTIVE_COLOR;
		toggleButton.classList.add('spixn-selected');

		buybackButton.style.border = `2px solid ${SPIXN_GREEN}`;
		buybackButton.style.background = BUYBACK_SELECTION_AREA_BACKGROUND_COLOR;
		regularButton.style.border = `2px solid #E9E9EA`;
		regularButton.style.background = '#fff';

		buybackMark.innerHTML = createCheckCircleHTML();
		regularMark.innerHTML = createGrayCircleHTML();


		if(buybackSpixnMark) {
			buybackSpixnMark.innerHTML = createSpixnMarkInSquareSVG(true);
		}




	} else {
		toggleButton.style.background = SPIXN_BUTTON_INACTIVE_BACKGROUND;
		toggleButton.style.border = `1px solid ${SPIXN_GREEN}`;
		toggleButton.style.color = SPIXN_BUTTON_INACTIVE_COLOR;
		toggleButton.classList.remove('spixn-selected');

		buybackButton.style.border = `2px solid #E9E9EA`;
		buybackButton.style.background = '#fff';
		regularButton.style.border = `2px solid ${SPIXN_GREEN}`;
		regularButton.style.background = BUYBACK_SELECTION_AREA_BACKGROUND_COLOR;

		buybackMark.innerHTML = createGrayCircleHTML();
		regularMark.innerHTML = createCheckCircleHTML();
		if(buybackSpixnMark) {
			buybackSpixnMark.innerHTML = createSpixnMarkInSquareSVG(false);
		}

	}

	// マークも更新
	if (window.buybackMark) {
		window.buybackMark.innerHTML = enabled ? createCheckCircleHTML() : createGrayCircleHTML();
	}
}

function modifyOriginalButton(originalButton, buybackInfo) {
	// 元のクリックイベントを保存
	const originalOnClick = originalButton.onclick;

	// 新しいクリックハンドラーを設定
	originalButton.onclick = null;
	
	// 新しいイベントリスナーを追加
	originalButton.addEventListener('click', function(e) {

		if (buybackToggleEnabled) {
			// バイバック保証が有効な場合、両方をカートに追加
			e.preventDefault();
			e.stopPropagation();
			addBothToCart(buybackInfo, originalButton);
			// addBuybackToCart(buybackInfo, originalButton);
		} else {
			// バイバック保証が無効な場合、プロンプトモーダルを表示
			// showBuybackPromptModal(buybackInfo, originalButton);
		}
	});
}

// --- 既存の addSingleToCart を書き換え ---
function addSingleToCart(originalButton) {
	const currentVariantId = getCurrentVariantId();
	const currentQuantity = getCurrentQuantity();

	fetch(window.Shopify.routes.root + 'cart/add.js', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({
			items: [{ id: currentVariantId, quantity: currentQuantity }],
			sections: ['cart-drawer', 'cart-icon-bubble'],
			sections_url: window.location.pathname
		})
	})
	.then(res => {
		if (!res.ok) throw new Error('Add to cart failed');
		return res.json();
	})
	.then(data => {
		log('Cart add response:', data);
		const notificationP = document.querySelector(PRODUCT_NOTIFICATION_SELECTOR);
		log("notificationP:", notificationP);
		if (notificationP) {
			notificationP.classList.add('product__notification--success');
			notificationP.textContent = '商品がカートに追加されました！';
		}
		return data;
	})
	.then(data => {
		if (CART_DISPLAY_MODE === 'drawer') {
			refreshSections(data.sections);
			document.querySelector('cart-drawer')?.open();
		} else if (CART_DISPLAY_MODE === 'debug') {
			log('Debug mode: Cart add completed, staying on page');
		} else {
			// ページ遷移方式
			window.location.href = '/cart';
		}
	})
	.catch(err => {
		console.error(err);
		alert('カート追加に失敗しました');
	});
}

// --- 既存の addBothToCart も同様に分岐 ---
async function addBothToCart(buybackInfo, originalButton) {
	const currentVariantId = getCurrentVariantId();
	const currentQuantity = getCurrentQuantity();
	
	// 現在のバリアントに対応するBuyback情報を取得
	const currentBuybackInfo = await getBuybackInformation(currentVariantId);
	if (!currentBuybackInfo) {
		alert('選択された商品にはバイバック保証がありません');
		return;
	}
	
	const buybackVariantId = currentBuybackInfo.buyback_variant_id;

	log('Adding both to cart:', {
		currentVariantId,
		buybackVariantId,
		currentQuantity,
		originalBuybackVariantId: buybackInfo.buyback_variant_id,
		updatedBuybackVariantId: buybackVariantId
	});

	fetch(window.Shopify.routes.root + 'cart/add.js', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({
			items: [
				{ id: currentVariantId, quantity: currentQuantity },
				{ id: buybackVariantId, quantity: currentQuantity }
			]
		})
	})
	.then(res => {
		if (!res.ok) throw new Error('Add to cart failed');
		return res.json();
	})
	.then(data => {
		log('Cart add response:', data);
		const notificationP = document.querySelector(PRODUCT_NOTIFICATION_SELECTOR);
		log("notificationP:", notificationP);
		if (notificationP) {
			notificationP.classList.add('product__notification--success');
			notificationP.textContent = '商品がカートに追加されました！';
		}
		return data;
	})
	.then(async data => {
		log('Both items added to cart successfully');
		if (CART_DISPLAY_MODE === 'drawer') {
			log('Refreshing cart drawer by fetching current page');
			await refreshCartDrawerFromPage();
			// document.querySelector('cart-drawer')?.open();
			// alert('商品がカートに追加されました');
			// リロード実行
			// window.location.reload();
		} else if (CART_DISPLAY_MODE === 'debug') {
			log('Debug mode: Cart add completed, staying on page');
		} else {
			window.location.href = '/cart';
		}
	})
	.catch(err => {
		console.error(err);
		alert('カート追加に失敗しました');
	});
}

async function addBuybackToCart(buybackInfo, originalButton) {
	const currentVariantId = getCurrentVariantId();
	const currentQuantity = getCurrentQuantity();
	
	// 現在のバリアントに対応するBuyback情報を取得
	const currentBuybackInfo = await getBuybackInformation(currentVariantId);
	if (!currentBuybackInfo) {
		alert('選択された商品にはバイバック保証がありません');
		return;
	}
	
	const buybackVariantId = currentBuybackInfo.buyback_variant_id;

	log('Adding both to cart:', {
		currentVariantId,
		buybackVariantId,
		currentQuantity,
		originalBuybackVariantId: buybackInfo.buyback_variant_id,
		updatedBuybackVariantId: buybackVariantId
	});

	fetch(window.Shopify.routes.root + 'cart/add.js', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({
			items: [
				{ id: buybackVariantId, quantity: currentQuantity }
			],
			sections: ['cart-drawer', 'cart-icon-bubble'],
			sections_url: window.location.pathname
		})
	})
	.then(res => {
		if (!res.ok) throw new Error('Add to cart failed');
		return res.json();
	})
	.then(data => {
		log('Cart add response:', data);
		const notificationP = document.querySelector(PRODUCT_NOTIFICATION_SELECTOR);
		log("notificationP:", notificationP);
		if (notificationP) {
			notificationP.classList.add('product__notification--success');
			notificationP.textContent = '商品がカートに追加されました！';
		}
		return data;
	})
	.then(data => {
		if (CART_DISPLAY_MODE === 'drawer') {
			refreshSections(data.sections);
			document.querySelector('cart-drawer')?.open();
		} else if (CART_DISPLAY_MODE === 'debug') {
			log('Debug mode: Cart add completed, staying on page');
		} else {
			window.location.href = '/cart';
		}
	})
	.catch(err => {
		console.error(err);
		alert('カート追加に失敗しました');
	});
}

/**
 * カートアイテムのイベントリスナーを再バインド
 * @param {HTMLElement} cartDrawerElement - cart-drawer要素
 */
function rebindCartItemEvents(cartDrawerElement) {
	log('[SPIXN] Rebinding cart item events');
	
	// 削除ボタンのイベントリスナーを再設定
	const deleteButtons = cartDrawerElement.querySelectorAll('[data-cart-item-delete]');
	deleteButtons.forEach(button => {
		button.addEventListener('click', function(evt) {
			evt.preventDefault();
			
			const item = evt.target.closest('[data-cart-item]');
			if (!item) return;
			
			const lineNumber = parseInt(item.getAttribute('data-cart-item-line-number'));
			
			log('[SPIXN] Removing cart item, line:', lineNumber);
			
			// theme.jsと同じ方式で/cart/change.jsを直接呼び出し
			fetch('/cart/change.js', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					line: lineNumber,
					quantity: 0
				})
			})
			.then(res => {
				if (!res.ok) throw new Error('Remove item failed');
				return res.json();
			})
			.then(() => {
				log('[SPIXN] Item removed successfully, refreshing cart');
				return refreshCartDrawerFromPage();
			})
			.catch(err => {
				console.error('[SPIXN] Failed to remove item:', err);
				alert('商品の削除に失敗しました');
			});
		});
	});
	
	// 数量変更のイベントリスナーを再設定
	const quantityInputs = cartDrawerElement.querySelectorAll('[data-cart-item-input-quantity]');
	quantityInputs.forEach(input => {
		// debounce処理を追加（theme.jsと同様に500ms）
		const debouncedHandler = debounce(function(evt) {
			const item = evt.target.closest('[data-cart-item]');
			if (!item) return;
			
			const lineNumber = parseInt(item.getAttribute('data-cart-item-line-number'));
			const quantity = evt.target.value;
			
			// 空の場合は何もしない
			if (quantity === '') return;
			
			log('[SPIXN] Changing cart item quantity, line:', lineNumber, 'quantity:', quantity);
			
			// theme.jsと同じ方式で/cart/change.jsを直接呼び出し
			fetch('/cart/change.js', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					line: lineNumber,
					quantity: parseInt(quantity)
				})
			})
			.then(res => {
				if (!res.ok) throw new Error('Change quantity failed');
				return res.json();
			})
			.then(() => {
				log('[SPIXN] Quantity changed successfully, refreshing cart');
				return refreshCartDrawerFromPage();
			})
			.catch(err => {
				console.error('[SPIXN] Failed to change quantity:', err);
				alert('数量の変更に失敗しました');
			});
		}, 500);
		
		input.addEventListener('input', debouncedHandler);
		
		// 空欄時のblurハンドラー
		input.addEventListener('blur', function(evt) {
			if (evt.target.value === '') {
				log('[SPIXN] Quantity input is empty, refreshing cart');
				refreshCartDrawerFromPage();
			}
		});
	});
	
	log('[SPIXN] Cart item events rebound successfully');
}

/**
 * 現在のページをfetchしてcart-drawerセクションを更新
 */
async function refreshCartDrawerFromPage() {
	try {
		log('[SPIXN] Fetching current page for cart-drawer update:', window.location.pathname);
		
		const response = await fetch(window.location.pathname, {
			method: 'GET',
			headers: {
				'Accept': 'text/html'
			}
		});
		
		if (!response.ok) {
			throw new Error('Failed to fetch current page');
		}
		
		const html = await response.text();
		const parser = new DOMParser();
		const doc = parser.parseFromString(html, 'text/html');
		
		// data-section-id="cart-drawer"を持つ要素を探す
		const newCartDrawer = doc.querySelector('[data-section-id="cart-drawer"]');
		const oldCartDrawer = document.querySelector('[data-section-id="cart-drawer"]');
		
		if (newCartDrawer && oldCartDrawer && oldCartDrawer.parentNode) {
			log('[SPIXN] Replacing cart-drawer element');
			oldCartDrawer.parentNode.replaceChild(newCartDrawer, oldCartDrawer);
			
			// イベントリスナーを再バインド
			rebindCartItemEvents(newCartDrawer);
			
			log('[SPIXN] Cart drawer updated successfully');
		} else {
			log('[SPIXN] Cart drawer elements not found:', {
				newFound: !!newCartDrawer,
				oldFound: !!oldCartDrawer
			});
		}
		
		// カートアイコン部分を更新
		const newCartIcon = doc.querySelector('.site-header__cart');
		const oldCartIcon = document.querySelector('.site-header__cart');
		
		if (newCartIcon && oldCartIcon && oldCartIcon.parentNode) {
			log('[SPIXN] Replacing cart icon element');
			// 内側のHTMLのみを置き換え（イベントリスナーを保持するため）
			oldCartIcon.innerHTML = newCartIcon.innerHTML;
			log('[SPIXN] Cart icon updated successfully');
		} else {
			log('[SPIXN] Cart icon elements not found:', {
				newFound: !!newCartIcon,
				oldFound: !!oldCartIcon
			});
		}
		
	} catch (error) {
		console.error('[SPIXN] Failed to refresh cart drawer from page:', error);
		throw error;
	}
}

function refreshSections(sections) {
	const parser = new DOMParser();
	Object.entries(sections).forEach(([sectionId, html]) => {
		const doc = parser.parseFromString(html, 'text/html');

		if (sectionId === 'cart-drawer') {
			const newDrawer = doc.querySelector('cart-drawer');
			const oldDrawer = document.querySelector('cart-drawer');
			if (newDrawer && oldDrawer && oldDrawer.parentNode) {
				oldDrawer.parentNode.replaceChild(newDrawer, oldDrawer);
			}
		}
		else if (sectionId === 'cart-icon-bubble') {
			const newBadge = doc.querySelector('[data-cart-count]');
			const oldBadge = document.querySelector('[data-cart-count]');
			if (newBadge && oldBadge) {
				oldBadge.textContent = newBadge.textContent;
			}
		}
	});
}

async function showBuybackPromptModal(buybackInfo, originalButton) {
	const plan = buybackInfo.plans[0];

	if (isModalVisible) return;
	isModalVisible = true;

	// ダイアログ内のpタグのmarginを0にするスタイルを追加
	addModalStyles();

	const modal = document.createElement('div');
	modal.id = 'spixn-buyback-modal';
	Object.assign(modal.style, {
		position: 'fixed',
		top: '0',
		left: '0',
		width: '100vw',
		height: '100vh',
		backgroundColor: 'rgba(0,0,0,0.6)',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		zIndex: '10000',
	});

	const dialog = document.createElement('div');
	Object.assign(dialog.style, {
		backgroundColor: 'white',
		borderRadius: '12px',
		width: '90%',
		maxWidth: '520px',
		padding: `${calcSize('2rem')} ${calcSize('1.5rem')}`,
		fontSize: calcSize('0.95rem'),
		lineHeight: '1.6',
		position: 'relative',
		fontFamily: BASE_FONT_FAMILY,
	});

	const underlineStyle = `
		text-decoration: underline;
		text-decoration-color: #FFD1D1;
		text-decoration-thickness: 4px;
		text-decoration-skip-ink: none;
		text-underline-offset: ${calcSize('-0.05rem')};
	`;
	const feeLabel = buybackInfo.insurance_fee === 0 ? '無料' : 
		`手数料 ￥${buybackInfo.insurance_fee.toLocaleString()}`;
	dialog.innerHTML = `
		<div style="display: flex; justify-content: center; align-items: center; margin-bottom: ${calcSize('0.8rem')}; margin-top: 10px;margin-right: 30px;">
			<div id="spixn-buyback-prompt-title" style="display: flex; flex-direction:column; align-items: center; font-weight: bold; ;justify-content: center;font-size: ${calcSize('1.0rem')}">
				<div>
					この商品には
					<span style="color: #F3004D;">${feeLabel}</span>の
					バイバック保証がつけられます！利用しますか？
				</div>
			</div>
		</div>
		<ul style="display: flex; flex-direction: column; justify-content: center; align-items: flex-start; margin: ${calcSize('1rem')} auto; font-weight: 600; font-size: ${calcSize("0.85rem")}">
			<li style="list-style: disc;">
			任意で商品を<span style="${underlineStyle}">spixnにリセールできます。</span> <br />
			保証期間内${plan.insurance_period_days / 365}年であれば、<span style="${underlineStyle}">査定ランクに応じて買取を保証。</span>
			購入後のメールから<span style="${underlineStyle}">保証内容の確認や管理ができます。</span>
			</li>
		</ul>
		<div>
			<div style="margin-top: ${calcSize('1.5rem')}; font-size: ${calcSize('0.85rem')}; text-align: center;">
				<a id="spixn-show-buyback-modal-button" style="color: ${SPIXN_BASE_COLOR}; text-decoration: underline;cursor: pointer;">
					この商品のバイバック保証詳細を確認する
				</a>
			</div>
		</div>
		<div style="margin-top: ${calcSize('1.5rem')}; text-align: center;">
			<button id="spixn-buyback-modal-toggle" style="background: ${SPIXN_BUTTON_ACTIVE_BACKGROUND}; color: ${SPIXN_BUTTON_ACTIVE_COLOR}; font-weight: bold; padding: ${calcSize('0.4rem')} ${calcSize('0.4rem')}; border-radius: 6px; border:none;font-size: ${calcSize('0.72rem')}; cursor: pointer; width: 100%;display: flex; justify-content: center; align-items: center;">
				最大￥${plan.a_price.toLocaleString()}のバイバック保証をつける
			</button>
		</div>
		<div style="margin-top: ${calcSize('1.5rem')}; text-align: center;">
			<button id="spixn-close-modal2" style="border:none; background:none; color:#222222; font-weight: bold; font-size: ${calcSize('0.9rem')}; cursor: pointer;">
				バイバック保証なしでカートへ
			</button>
		</div>
		<a style="margin-top: ${calcSize('1rem')}; text-align: center; font-size: ${calcSize('0.7rem')}; color: #888;display:flex;justify-content:center;align-items:center;gap:${calcSize('0.5rem')};text-decoration: none;"
		   href="https://user.spixn.co.jp"
		   target="_blank"
		>
			<small style='font-size:${calcSize('0.7rem')};color:#888;'>
			${createSpixnMarkCircleSVG(USE_GREEN_MARK)}
			バイバック保証は <strong>spixn</strong> の提供するサービスです
			</small>
		</a>
		<button id="spixn-close-modal" style="position: absolute; top: ${calcSize('1rem')}; right: ${calcSize('1rem')}; background: none; border: none; font-size: ${calcSize('1.5rem')}; cursor: pointer;">×</button>
	`;

	modal.appendChild(dialog);
	document.body.appendChild(modal);

	const closeModal = e => {
		e.preventDefault();
		modal.remove();
		isModalVisible = false;
	};

	const showBuybackModalButton = document.getElementById('spixn-show-buyback-modal-button');
	showBuybackModalButton.addEventListener('click', async e => {
		e.preventDefault();
		closeModal(e);
		setTimeout(async () => {
			// ダイアログを開く時点で現在のバリエーションに基づいてbuyback情報を取得
			const currentVariantId = getCurrentVariantId();
			const currentBuybackInfo = await getBuybackInformation(currentVariantId);
			if (currentBuybackInfo) {
				showBuybackModal(currentBuybackInfo);
			} else {
				alert('選択された商品にはバイバック保証がありません');
			}
		}, 100);
	});

	document.getElementById('spixn-close-modal')?.addEventListener('click', closeModal);
	
	document.getElementById('spixn-close-modal2')?.addEventListener('click', e => {
		closeModal(e);
		setTimeout(() => {
			addSingleToCart(originalButton);
		}, 100);
	});

	const modalToggle = document.getElementById('spixn-buyback-modal-toggle');
	modalToggle.addEventListener('click', e => {
		// トグルを有効にして保証付きでカートに追加
		buybackToggleEnabled = true;
		updateToggleButtonState(window.buybackToggle, true);
		closeModal(e);
		setTimeout(() => {
			addBothToCart(buybackInfo, originalButton);
		}, 100);
	});
}

async function showBuybackModal(buybackInfo) {
	if (isModalVisible) return;
	isModalVisible = true;

	// ダイアログ内のpタグのmarginを0にするスタイルを追加
	addModalStyles();

	const plan = buybackInfo.plans[0];
	const selected = buybackToggleEnabled;

	const modal = document.createElement('div');
	modal.id = 'spixn-buyback-modal';
	Object.assign(modal.style, {
		position: 'fixed',
		top: '0',
		left: '0',
		width: '100vw',
		height: '100vh',
		backgroundColor: 'rgba(0,0,0,0.6)',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		zIndex: '10000',
	});

	const dialog = document.createElement('div');
	Object.assign(dialog.style, {
		backgroundColor: 'white',
		borderRadius: '12px',
		minWidth: '560px',
		width: '560px;',
		maxWidth: '560px',
		padding: '2rem 1.5rem',
		fontSize: '0.95rem',
		lineHeight: '1.6',
		position: 'relative',
		transformOrigin: "center center",
		transition: "transform 0.2s ease-out",
	});

	const baseWidth = 580; // 基準となる幅
	const baseHeight = 880; // 基準となる高さ
	function adjustScale() {
		const w = window.innerWidth;
		const h = window.innerHeight;
		// 幅と高さの縮小率を計算
		const scaleW = w < baseWidth ? (w / baseWidth) : 1;
		const scaleH = h < baseHeight ? (h / baseHeight) : 1;
		// 小さい方の縮小率を適用
		const scale = Math.min(scaleW, scaleH);
		dialog.style.transform = `scale(${scale})`;
	}
	adjustScale();

	window.addEventListener('resize', adjustScale);
	window.addEventListener('load', adjustScale);

	const blockStyle = `
		border-radius: 12px;
        margin: 1rem 0;
		color: ${SPIXN_BASE_COLOR};
	`;

	const priceRangeTitle = `
		<div style="display: flex; flex-direction: column; justify-content: end; align-items: end; margin-bottom: ${calcSize('0.8rem')}; font-size: ${calcSize('0.7rem')};font-weight: bold;">
			<span style="color: ${SPIXN_BASE_COLOR};">紫色: バイバック保証額</span>
			<span style="color: #A3A3A3;">グレー: 2次流通品の主要取引価格帯（spixn調査）</span>
		</div>
	`;

	// const maxPriceNum = plan.a_price;
	// const maxPrice = maxPriceNum.toLocaleString();
	// const insuranceFee = buybackInfo.insurance_fee.toLocaleString();
	// const maxPricePercentage = Math.round(plan.a_price_ratio * 100);

	// const buttonLabel = selected
	// 	? 'バイバック保証をはずす'
	// 	: `最大${SHOW_BUYBACK_PRICE_AS_PERCENTAGE ? '' : '￥'}${SHOW_BUYBACK_PRICE_AS_PERCENTAGE ? `${maxPricePercentage}%` : maxPrice} のバイバック保証をつける`;

	dialog.innerHTML = `
		<div style="display: flex; justify-content: center; align-items: baseline; margin-bottom: ${calcSize('0.8rem')}; position: relative;">
			<div id="spixn-buyback-title" style="word-break: keep-all; display: flex; align-items: center; gap: ${calcSize('0.5rem')}; font-weight: 600; font-size: ${calcSize('1.0rem')};">
				品質ランク別バイバック保証
			</div>
			<div style="white-space:nowrap; display: flex; justify-content: space-between; gap: 10px; align-items: center; font-size: ${calcSize('0.6rem')}; color: #666; position: absolute; top: -11px; right: 0;">
				<p id="spixn-buyback-period" style="border-radius: 20px; padding: 0 ${calcSize('0.5rem')};margin:0;">
					保証期間 <span style="font-size:${calcSize('1.0rem')}">${plan.insurance_period_days / 365}</span>年間
				</p>
				<button id="spixn-close-modal" style="background: none; border: none; font-size: ${calcSize('1.5rem')}; cursor: pointer; padding: 0;">×</button>
			</div>
		</div>

		<p style="font-size: ${calcSize('0.7rem')}; margin-bottom: ${calcSize('1.2rem')}; text-align: center; font-weight: 600;">
			受取時の状態（A・B・C）を評価し、該当するバイバック保証額をお支払いします。<br />
			Cに至らない品質の場合は再評価し適正額をお支払い、 <br />
			あきらかなキズ・汚れは保証対象外となります。 <br />
		</p>

		<div id="spixn-buyback-modal-core" style="${blockStyle}">
		    <div id="spixn-buyback-modal-core-content">
				<div id="spixn-buyback-modal-core-title" style="background-color: #f1eaff; color: ${SPIXN_BASE_COLOR}; padding: ${calcSize('0.3rem')}; border-radius: 20px; font-size: ${calcSize('0.85rem')}; margin: -22px auto ${calcSize('1rem')}; text-align: center; width: ${calcSize('16rem', ' + 25px')};">
					保証期間内であればいつでも利用可能
				</div>
				<p style="font-size: ${calcSize('0.75rem')}; margin-bottom: ${calcSize('1.2rem')}; text-align: left;">
					受取時の状態（A・B・C）を評価し、該当する保証金額をお支払い。
					Cに至らない品質の場合は再評価し、適正額をお支払いします。
				</p>
				${BUYBACK_MODAL_SHOW_PRICE_RANGE ? priceRangeTitle : ''}
				<ul style="list-style: none; padding: 0; margin: 0;">
					${['A', 'B', 'C']
						.map((grade, idx) => {
							const labels = [
								'未使用に近い',
								'ほとんどキズがない',
								'ややキズや汚れがある',
							];
							const descriptions = [
								'数回しか使用しておらず、傷や汚れがない',
								'よく見ないとわからない程度の傷や汚れがある',
								'目立たない傷や汚れがある',
							];
							const prices = [plan.a_price, plan.b_price, plan.c_price];
							const percentages = [
								plan.a_price_ratio,
								plan.b_price_ratio,
								plan.c_price_ratio,
							].map(p => Math.round(p * 100));
							const ranges = [
								`￥${plan.a_min_price.toLocaleString()} 〜 ￥${plan.a_max_price.toLocaleString()}`,
								`￥${plan.b_min_price.toLocaleString()} 〜 ￥${plan.b_max_price.toLocaleString()}`,
								`￥${plan.c_min_price.toLocaleString()} 〜 ￥${plan.c_max_price.toLocaleString()}`,
							].map(
								r => `<span style="font-size: ${calcSize('0.8rem')};color:#A3A3A3">${r}</span>`,
							);

							return `
							<li style="display: flex; justify-content: space-between; align-items: center; margin-bottom: ${calcSize('1rem')};">
								<div style="display: flex; align-items: center;">
									<div style="background: ${SPIXN_BASE_COLOR}; color: white; font-weight: bold; border-radius: 50%;width: ${calcSize('2rem')}; height: ${calcSize('2rem')}; min-width: ${calcSize('2rem')}; min-height: ${calcSize('2rem')}; text-align: center; line-height: ${calcSize('2rem')}; margin-right: ${calcSize('0.8rem')};font-size: ${calcSize('0.8rem')};">
									${grade}
									</div>
									<div>
										<div style="font-size: ${calcSize('0.75rem')}; font-weight: bold; text-align: left;">${labels[idx]}</div>
										<div style="text-align: left;">${descriptions[idx]}</div>
									</div>
								</div>
								<div style="color: ${SPIXN_BASE_COLOR}; font-size: ${calcSize('1.5rem')}; white-space: nowrap;font-weight: 500;display:flex; flex-direction:column;align-items:end;">
									<p style="display:flex; align-items: baseline;">
										<span style="font-size: ${calcSize('0.8rem')};">${SHOW_BUYBACK_PRICE_AS_PERCENTAGE ? '' : '￥'}</span>
										${SHOW_BUYBACK_PRICE_AS_PERCENTAGE ? percentages[idx] : prices[idx].toLocaleString()}
										<span style="font-size: ${calcSize('0.8rem')};">${SHOW_BUYBACK_PRICE_AS_PERCENTAGE ? '%' : ''}</span>
									</p>
									${BUYBACK_MODAL_SHOW_PRICE_RANGE ? ranges[idx] : ''}
								</div>
							</li>
						`;
						})
						.join('')}
				</ul>
			</div>
		</div>

		<div style="margin-top: ${calcSize('0.9rem')};margin-bottom: ${calcSize('0.9rem')}; text-align: center;font-size: ${calcSize('0.75rem')};">
			<a href="/pages/spixn" target="_blank" style="color: ${SPIXN_BASE_COLOR}; text-decoration: underline;">バイバック保証について更に詳しくみる</a>
		</div>
		<div id="spixn-buyback-modal-sub-message" style="
			margin-bottom: 30px;
			text-align: center;
			color: #F3004D;
			font-weight: 500;
			font-size: ${calcSize('0.72rem')};
		">
			${createSpixnMarkCircleSVG(USE_GREEN_MARK)}
			この保証は外部サービス「<a style="color: inherit;" target="_blank" href="https://user.spixn.co.jp">spixn</a>」によって提供されています。 <br />
			保証を有効にするには、購入後に注文時と同じメールアドレスでspixnに会員登録してください。
		</div>		

		<div style="margin-top: ${calcSize('1.5rem')}; text-align: center;">
			<button id="spixn-close-modal2" style="border:none; background:none; color:${SPIXN_BASE_COLOR}; font-weight: bold; font-size: ${calcSize('0.9rem')}; cursor: pointer;">
				閉じる
			</button>
		</div>
		<a href="https://user.spixn.co.jp/contact" target="_blank" style="margin-top: ${calcSize('2rem')}; text-align: center; font-size: ${calcSize('0.7rem')}; color: #26202C;display:block;text-decoration: none;">
			バイバック保証サービスの運営窓口にお問い合わせはこちら
			<span style="border: 1px solid #A3A3A3; border-radius: 50%; background-color:#A3A3A3; color: #FFFFFF;padding: 0 ${calcSize('0.4rem')}; font-size: ${calcSize('0.75rem')}; margin-left: ${calcSize('0.3rem')};">i</span>
		</a>
	`;

	modal.appendChild(dialog);
	document.body.appendChild(modal);

	const closeModal = e => {
		e.preventDefault();
		modal.remove();
		isModalVisible = false;
	};

	document.getElementById('spixn-close-modal')?.addEventListener('click', closeModal);
	document.getElementById('spixn-close-modal2')?.addEventListener('click', closeModal);

	// const modalToggle = document.getElementById('spixn-buyback-modal-toggle');
	// modalToggle.addEventListener('click', () => {
	// 	buybackToggleEnabled = !buybackToggleEnabled;
	// 	updateToggleButtonState(window.buybackToggle, buybackToggleEnabled);
	// 	syncModalState(buybackInfo);
	// });

	syncModalState(buybackInfo);
}

function syncModalState(buybackInfo) {
	const plan = buybackInfo.plans[0];
	const modalToggle = document.getElementById('spixn-buyback-modal-toggle');
	const title = document.getElementById('spixn-buyback-title');
	const period = document.getElementById('spixn-buyback-period');
	const core = document.getElementById('spixn-buyback-modal-core');
	const coreContent = document.getElementById('spixn-buyback-modal-core-content');
	const coreTitle = document.getElementById('spixn-buyback-modal-core-title');

	const isSelected = buybackToggleEnabled;

	if (modalToggle) {
		modalToggle.style.background = isSelected ? SPIXN_BUTTON_INACTIVE_BACKGROUND : SPIXN_BUTTON_ACTIVE_BACKGROUND;
		modalToggle.style.color = isSelected ? SPIXN_BUTTON_INACTIVE_COLOR : SPIXN_BUTTON_ACTIVE_COLOR;
		modalToggle.style.border = isSelected ? `1px solid ${SPIXN_GREEN}` : 'none';
		
		const maxPriceNum = plan.a_price;
		const maxPrice = maxPriceNum.toLocaleString();
		const maxPricePercentage = Math.round(plan.a_price_ratio * 100);

		const buttonLabel = isSelected
			? 'バイバック保証をはずす'
			: `最大${SHOW_BUYBACK_PRICE_AS_PERCENTAGE ? '' : '￥'}${SHOW_BUYBACK_PRICE_AS_PERCENTAGE ? `${maxPricePercentage}%` : maxPrice} のバイバック保証をつける`;

		modalToggle.textContent = buttonLabel;
	}

	if (core) {
		core.style.border = 'none';
		core.style.background = isSelected ? `${SPIXN_BUTTON_ACTIVE_BACKGROUND}` : '#F5F4EE';
		core.style.padding = '4px';
	}
	if (coreContent) {
		coreContent.style.backgroundColor = isSelected ? SPIXN_LIGHT_GREEN : 'white';
		coreContent.style.borderRadius = '9px';
		coreContent.style.padding = '1rem';
	}

	if (coreTitle) {
		coreTitle.style.background = isSelected ? SPIXN_BUTTON_ACTIVE_BACKGROUND : '#F5F4EE';
		coreTitle.style.color = isSelected ? 'white' : '#4A2D57';
	}

	if (title) {
		title.style.color = isSelected ? '#222222' : '#A3A3A3';
		title.innerHTML = `${isSelected ? createCheckCircleHTML() : createGrayCircleHTML()}バイバック保証 ${isSelected ? '設定中' : '未選択'}`;
	}
	
	if (period) {
		period.style.backgroundColor = isSelected ? '#4A2D57' : 'transparent';
		period.style.color = isSelected ? 'white' : '#A3A3A3';
	}
	toggleAcceleratedCheckoutBlock(isSelected);
}

function createGrayCircleHTML() {
	return `<div style="display: flex;align-items:center; width: 14px;height:14px;text-align: center;line-height: ${calcSize('1.5rem')};border-radius: 50%;border: solid 1px #E9E9EA;"></div>`;
}

function createCheckCircleHTML(fgColor = 'white', bgColor = SPIXN_GREEN_FOR_CHECK) {
	return `
		<div style="display: flex; align-items: center">
			<svg width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="10" cy="10" r="10" fill="${bgColor}"/>
			<g clip-path="url(#clip0_1_8223)">
			<path fill-rule="evenodd" clip-rule="evenodd" d="M15.6818 5.89941C15.8492 6.06684 15.9432 6.29391 15.9432 6.53066C15.9432 6.76741 15.8492 6.99447 15.6818 7.16191L8.98952 13.8542C8.90108 13.9426 8.79609 14.0128 8.68052 14.0607C8.56496 14.1086 8.4411 14.1332 8.31601 14.1332C8.19093 14.1332 8.06706 14.1086 7.9515 14.0607C7.83594 14.0128 7.73094 13.9426 7.6425 13.8542L4.3175 10.5298C4.23222 10.4474 4.1642 10.3489 4.11741 10.2399C4.07062 10.131 4.04599 10.0139 4.04496 9.8953C4.04393 9.77675 4.06652 9.65918 4.11141 9.54945C4.1563 9.43972 4.2226 9.34003 4.30643 9.2562C4.39027 9.17237 4.48996 9.10607 4.59968 9.06118C4.70941 9.01628 4.82698 8.99369 4.94554 8.99472C5.06409 8.99575 5.18125 9.02038 5.29018 9.06718C5.39912 9.11397 5.49764 9.18199 5.58 9.26727L8.31571 12.003L14.4187 5.89941C14.5016 5.81644 14.6001 5.75062 14.7084 5.70571C14.8168 5.66081 14.9329 5.6377 15.0502 5.6377C15.1675 5.6377 15.2837 5.66081 15.3921 5.70571C15.5004 5.75062 15.5989 5.81644 15.6818 5.89941Z" fill="${fgColor}" stroke="${fgColor}" stroke-width="0.6"/>
			</g>
			<defs>
			<clipPath id="clip0_1_8223">
			<rect width="14.2857" height="14.2857" fill="${fgColor}" transform="translate(2.85693 2.85742)"/>
			</clipPath>
			</defs>
			</svg>
		</div>
	`;
}

function createDoubleDownArrowSVG() {
	return `
<svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.02062 4.3748L3.97938 4.3748L-9.28057e-09 0.212314L0.752578 -3.16795e-07L3.97938 3.39703L4.02062 3.39703L7.24742 -3.28962e-08L8 0.212315L4.02062 4.3748Z" fill="#4A2D57"/>
<path d="M4.02062 6.9998L3.97938 6.9998L-9.42831e-09 2.83731L0.752578 2.625L3.97938 6.02203L4.02062 6.02203L7.24742 2.625L8 2.83731L4.02062 6.9998Z" fill="#4A2D57"/>
</svg>

	`;
}

function createPoweredBySpixnSVG() {
	return `
<svg width="23" height="18" viewBox="0 0 23 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.6001 14.347C2.69467 14.7065 2.98826 14.9085 3.45471 14.9085C3.91633 14.9085 4.08436 14.743 4.08436 14.4694C4.08436 14.1795 3.89039 14.0658 3.24375 13.9072C1.7728 13.5445 1.53201 13.0891 1.53201 12.4521C1.53201 11.7887 2.00097 11.0845 3.36312 11.0845C4.7326 11.0845 5.19606 11.8323 5.23508 12.4441H4.04648C4.00631 12.2772 3.89498 11.962 3.30711 11.962C2.89392 11.962 2.76032 12.1457 2.76032 12.3481C2.76032 12.5726 2.90058 12.6812 3.63261 12.8531C5.1389 13.2034 5.35215 13.7199 5.35215 14.3817C5.35215 15.1293 4.78333 15.81 3.40673 15.81C2.0361 15.81 1.47003 15.1484 1.37109 14.348L2.6001 14.347Z" fill="#231815"/>
<path d="M7.28327 15.3045V17.4335H6.04095V12.2769C6.04095 11.9117 6.04095 11.5509 6.03223 11.1887H7.24287C7.26667 11.3752 7.28016 11.563 7.28327 11.7511C7.47701 11.4198 7.88009 11.084 8.59583 11.084C9.60974 11.084 10.3941 11.9333 10.3941 13.3336C10.3941 14.9269 9.51838 15.8092 8.42458 15.8092C7.78735 15.809 7.4552 15.5687 7.28327 15.3045ZM9.12562 13.3815C9.12562 12.554 8.79071 12.0869 8.19595 12.0869C7.48596 12.0869 7.23414 12.5425 7.23414 13.4522C7.23414 14.314 7.46691 14.8153 8.14247 14.8153C8.80403 14.8153 9.12562 14.3011 9.12562 13.3815Z" fill="#231815"/>
<path d="M11.1268 11.1891H12.377V15.7043H11.1268V11.1891ZM12.4979 9.8017C12.4979 9.94925 12.4542 10.0935 12.3722 10.2162C12.2902 10.3389 12.1737 10.4345 12.0374 10.4909C11.9011 10.5474 11.7511 10.5622 11.6063 10.5334C11.4616 10.5046 11.3287 10.4336 11.2244 10.3292C11.12 10.2249 11.049 10.092 11.0202 9.94724C10.9914 9.80252 11.0062 9.65252 11.0626 9.5162C11.1191 9.37988 11.2147 9.26337 11.3374 9.18139C11.4601 9.09942 11.6043 9.05566 11.7519 9.05566C11.8499 9.05566 11.9469 9.07496 12.0374 9.11245C12.1279 9.14994 12.2101 9.2049 12.2794 9.27417C12.3487 9.34345 12.4036 9.42569 12.4411 9.5162C12.4786 9.60672 12.4979 9.70373 12.4979 9.8017Z" fill="#231815"/>
<path d="M14.4004 11.189C14.8709 12.0383 15.0622 12.3732 15.1983 12.6041H15.207C15.3626 12.3305 15.6374 11.8331 16.0045 11.189H17.3923L15.9282 13.3385L17.3879 15.7042H15.9737C15.5683 14.9398 15.3144 14.4458 15.1818 14.1864H15.173C15.0534 14.424 14.7454 15.0096 14.3756 15.7042H13.0098L14.4077 13.504L13.018 11.189H14.4004Z" fill="#231815"/>
<path d="M17.9296 12.3268C17.9296 11.943 17.9296 11.5234 17.9209 11.1891H19.1315C19.1568 11.3058 19.1731 11.6193 19.1797 11.7646C19.3333 11.4809 19.6985 11.0845 20.4895 11.0845C21.3965 11.0845 21.9857 11.6974 21.9857 12.832V15.7044H20.7356V12.9709C20.7356 12.4634 20.5664 12.0956 20.0148 12.0956C19.4837 12.0956 19.1797 12.3908 19.1797 13.1881V15.7044H17.9296V12.3268Z" fill="#231815"/>
<path d="M0.617323 6.04785V3.13876H1.70823C1.93172 3.13876 2.11922 3.18043 2.27073 3.26376C2.42319 3.34709 2.53825 3.46168 2.6159 3.60751C2.6945 3.7524 2.7338 3.91717 2.7338 4.10183C2.7338 4.28838 2.6945 4.4541 2.6159 4.59899C2.5373 4.74387 2.4213 4.85798 2.26789 4.94132C2.11448 5.0237 1.92556 5.0649 1.70113 5.0649H0.978118V4.63166H1.63011C1.76079 4.63166 1.8678 4.60893 1.95113 4.56348C2.03446 4.51802 2.09602 4.45552 2.13579 4.37598C2.17651 4.29643 2.19687 4.20505 2.19687 4.10183C2.19687 3.99861 2.17651 3.9077 2.13579 3.8291C2.09602 3.7505 2.03399 3.68942 1.94971 3.64586C1.86638 3.60136 1.75889 3.5791 1.62727 3.5791H1.14431V6.04785H0.617323ZM4.04927 6.09047C3.8362 6.09047 3.65154 6.04359 3.49529 5.94984C3.33904 5.85609 3.21783 5.72493 3.13166 5.55637C3.04643 5.38781 3.00381 5.19084 3.00381 4.96547C3.00381 4.74009 3.04643 4.54264 3.13166 4.37314C3.21783 4.20363 3.33904 4.072 3.49529 3.97825C3.65154 3.8845 3.8362 3.83762 4.04927 3.83762C4.26234 3.83762 4.447 3.8845 4.60325 3.97825C4.7595 4.072 4.88023 4.20363 4.96546 4.37314C5.05164 4.54264 5.09472 4.74009 5.09472 4.96547C5.09472 5.19084 5.05164 5.38781 4.96546 5.55637C4.88023 5.72493 4.7595 5.85609 4.60325 5.94984C4.447 6.04359 4.26234 6.09047 4.04927 6.09047ZM4.05211 5.67853C4.16764 5.67853 4.26423 5.64681 4.34188 5.58336C4.41953 5.51897 4.4773 5.43279 4.51518 5.32484C4.554 5.21689 4.57342 5.09662 4.57342 4.96404C4.57342 4.83052 4.554 4.70978 4.51518 4.60183C4.4773 4.49293 4.41953 4.40628 4.34188 4.34189C4.26423 4.27749 4.16764 4.24529 4.05211 4.24529C3.93374 4.24529 3.83525 4.27749 3.75666 4.34189C3.679 4.40628 3.62077 4.49293 3.58194 4.60183C3.54406 4.70978 3.52512 4.83052 3.52512 4.96404C3.52512 5.09662 3.54406 5.21689 3.58194 5.32484C3.62077 5.43279 3.679 5.51897 3.75666 5.58336C3.83525 5.64681 3.93374 5.67853 4.05211 5.67853Z" fill="#26202C"/>
</svg>
	`;
}

function createSpixnMarkInSquareSVG(active) {
    const fillColor = active ? '#3D6073' : '#E9E9EA';

	return `
	<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 0H23C24.1046 0 25 0.895431 25 2V25H2C0.89543 25 0 24.1046 0 23V0Z" fill="${fillColor}"/>
<path d="M16.2294 12.6221C16.0061 12.8392 15.7462 13.0807 15.4648 13.3376L16.8716 14.42C17.3486 13.9766 17.7615 13.573 18.0612 13.2734L18.1468 13.1877C18.3456 12.989 18.526 12.8086 18.7064 12.6221H16.2294Z" fill="white"/>
<path d="M18.1208 11.7852C18.7204 11.7852 19.2064 11.2992 19.2064 10.6997C19.2064 10.1002 18.7204 9.61426 18.1208 9.61426C17.5212 9.61426 17.0352 10.1002 17.0352 10.6997C17.0352 11.2992 17.5212 11.7852 18.1208 11.7852Z" fill="white"/>
<path d="M14.5515 14.1762L13.2305 13.158L9.7014 10.4825C9.53533 10.3359 9.4031 10.155 9.31387 9.95229C9.22463 9.74956 9.18052 9.52986 9.18458 9.3084C9.21516 8.4125 10.0623 7.70618 11.0714 7.7337C11.58 7.74208 12.0647 7.95086 12.4201 8.31466C12.6996 8.60615 12.8524 8.99637 12.8451 9.40013C12.8433 9.50321 12.83 9.60577 12.8054 9.70589L12.7656 9.83738C12.7318 9.92809 12.6909 10.016 12.6433 10.1003C12.5851 10.1984 12.5175 10.2905 12.4415 10.3755L12.0959 10.7577L13.4843 11.8279L13.7381 11.5436C13.8941 11.3702 14.0324 11.1818 14.1509 10.9809C14.2598 10.7946 14.3499 10.5979 14.4201 10.3939L14.4812 10.2012V10.1554C14.6166 9.62459 14.6137 9.068 14.4729 8.53864C14.3321 8.00927 14.0581 7.52479 13.6769 7.13134C13.3436 6.78309 12.9449 6.50393 12.5036 6.30981C12.0623 6.11569 11.5871 6.01042 11.1051 6H11.0011C9.07755 6 7.48428 7.44628 7.42617 9.26865C7.41392 9.75085 7.50846 10.2298 7.70302 10.6712C7.89757 11.1126 8.18733 11.5055 8.55155 11.8218L8.57602 11.8432L13.1357 15.3259C12.0806 16.0383 11.2794 16.2218 10.7381 16.2218C10.382 16.2352 10.0287 16.1546 9.71357 15.9882C9.39847 15.8219 9.13271 15.5755 8.94299 15.2739C8.80278 15.0444 8.72682 14.7814 8.72306 14.5124C8.71929 14.2435 8.78786 13.9785 8.92159 13.7451L8.95522 13.6931L7.59131 12.6229C7.52709 12.7146 7.46899 12.8033 7.42006 12.8859C7.13859 13.3843 6.99376 13.9482 7.00021 14.5205C7.00665 15.0929 7.16414 15.6534 7.45676 16.1453C7.79872 16.7117 8.28426 17.1777 8.86424 17.4961C9.44422 17.8145 10.098 17.974 10.7595 17.9585C11.9827 17.9585 13.2641 17.4418 14.6066 16.4297L15.8788 17.399H18.7564L14.5515 14.1762Z" fill="white"/>
</svg>
`;
}

function createSpixnMarkCircleSVG(useGreenMark=true) {
	const color = useGreenMark ? SPIXN_GREEN_FOR_MARK : SPIXN_BASE_COLOR;
	return `
		<svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg" style="vertical-align: text-top;">
		<g clip-path="url(#clip0_1427_3087)">
		<path d="M7.00123 13.0025C10.5918 13.0025 13.5025 10.0918 13.5025 6.50123C13.5025 2.9107 10.5918 0 7.00123 0C3.4107 0 0.5 2.9107 0.5 6.50123C0.5 10.0918 3.4107 13.0025 7.00123 13.0025Z" fill="${color}"/>
		<path d="M3.96566 9.09757C4.42183 9.55602 5.04143 9.81448 5.68816 9.8161H5.71277C6.06158 9.80932 6.40539 9.73191 6.72344 9.58853C7.04149 9.44516 7.32717 9.2388 7.56323 8.98192L7.60753 8.9327L7.87575 8.63496L9.59825 9.83579H11.3774L9.04951 8.21171L5.78905 5.92816L5.01146 5.3868C4.9124 5.31079 4.83161 5.21357 4.77501 5.10227C4.71841 4.99097 4.68744 4.86841 4.68437 4.74359C4.6813 4.61876 4.70622 4.49483 4.75728 4.38088C4.80834 4.26694 4.88426 4.16587 4.97947 4.08508C5.19671 3.89346 5.47725 3.78914 5.76691 3.79226C6.36486 3.79226 6.85209 4.20812 6.85455 4.71995C6.85491 4.77537 6.84913 4.83067 6.83732 4.88482L6.81763 4.9611C6.79964 5.01287 6.77742 5.06307 6.7512 5.1112C6.71941 5.16848 6.68146 5.22212 6.638 5.27114L6.48298 5.45324L7.32209 6.0389L7.41067 5.93801C7.49933 5.83491 7.57687 5.72273 7.64198 5.60334C7.70324 5.4932 7.75273 5.3769 7.78962 5.25638L7.82161 5.14565V5.11858C7.85105 4.98608 7.8659 4.85076 7.8659 4.71503C7.8659 3.64215 6.91606 2.77351 5.75952 2.77351C5.21493 2.76899 4.68831 2.96823 4.28309 3.3321C4.08469 3.50684 3.92586 3.7219 3.81722 3.96293C3.70859 4.20396 3.65265 4.46541 3.65315 4.72979C3.65661 5.01058 3.7227 5.28706 3.84658 5.53908C3.97046 5.79109 4.14901 6.01228 4.36922 6.18653L4.38398 6.19884L7.01941 8.037L6.8324 8.24617C6.68824 8.41205 6.51126 8.54624 6.31262 8.64027C6.11398 8.73429 5.898 8.78611 5.67832 8.79245C5.30467 8.79231 4.94597 8.64565 4.67926 8.38397C4.48976 8.18669 4.38319 7.92421 4.38152 7.65067V7.11177H3.36524V7.64082C3.36468 7.91118 3.41743 8.179 3.52045 8.42896C3.62348 8.67892 3.77476 8.90612 3.96566 9.09757Z" fill="white"/>
		<path d="M9.25796 5.54199L8.24414 6.68131L9.08325 7.26942L10.6212 5.54199H9.25796Z" fill="white"/>
		<path d="M10.5423 4.91367C10.9065 4.91367 11.2018 4.61842 11.2018 4.2542C11.2018 3.88998 10.9065 3.59473 10.5423 3.59473C10.1781 3.59473 9.88281 3.88998 9.88281 4.2542C9.88281 4.61842 10.1781 4.91367 10.5423 4.91367Z" fill="white"/>
		</g>
		<defs>
		<clipPath id="clip0_1427_3087">
		<rect width="13" height="13" fill="white" transform="translate(0.5)"/>
		</clipPath>
		</defs>
		</svg>
	`;
}

function createRightChevronSVG(){
	return `
		<svg width=20 height=20 viewBox="0 0 24 24" focusable="false">
		<path fill="currentColor" d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
		</svg>	
	`;
}

/**
 * zenlink要素の存在をチェック
 * @returns {boolean} zenlink要素が存在するかどうか
 */
function checkZenlinkElement() {
	return document.getElementById("zenlink5F8304A2-root") !== null;
}

/**
 * 元のボタンの動作を復元
 */
function restoreOriginalButton() {
	const originalButton = document.querySelector(ORIGINAL_ADD_TO_CART_BUTTON_SELECTOR) || document.querySelector(ALTERNATIVE_ADD_TO_CART_BUTTON_SELECTOR);
	if (!originalButton) {
		console.log('[SPIXN] Original button not found for restoration');
		return;
	}
	
	console.log('[SPIXN] Restoring original button behavior');
	
	// 新しいイベントリスナーを削除し、元の動作に戻すため、ボタンを複製して置き換える
	const newButton = originalButton.cloneNode(true);
	originalButton.parentNode.replaceChild(newButton, originalButton);
	
	// 元のShopifyの標準的なカート追加動作は、通常form submitまたはfetch('/cart/add.js')で処理される
	// ここでは特別な復元処理は不要（Shopifyのデフォルト動作に戻る）
}

/**
 * SPIXN機能を完全に無効化
 */
function disableSpixnFeatures() {
	// 無限ループ防止: 既に無効化済みの場合は何もしない
	if (spixnFeaturesDisabled) {
		console.log('[SPIXN] Features already disabled, skipping');
		return;
	}
	
	console.log('🛑 [SPIXN] Disabling SPIXN features due to zenlink detection');
	
	// フラグを先に設定して重複実行を防ぐ
	spixnFeaturesDisabled = true;
	
	// 1. オブザーバーを先に停止（再帰的な呼び出しを防ぐ）
	if (window.spixnZenlinkObserver) {
		console.log('[SPIXN] Stopping zenlink observer');
		window.spixnZenlinkObserver.disconnect();
		window.spixnZenlinkObserver = null;
	}
	
	if (window.spixnVariantObserver) {
		console.log('[SPIXN] Stopping variant observer');
		window.spixnVariantObserver.disconnect();
		window.spixnVariantObserver = null;
	}
	
	// 2. UIコンポーネントの削除（既存の安全な削除関数を活用）
	removeBuybackUI();
	
	// 3. 元のボタンの動作を復元
	restoreOriginalButton();
	
	// 4. グローバル変数のリセット
	buybackToggleEnabled = false;
	window.buybackToggle = null;
	window.buybackMark = null;
	isModalVisible = false;
	
	console.log('✅ [SPIXN] SPIXN features successfully disabled');
}

/**
 * zenlink要素の動的監視を設定
 */
function setupZenlinkObserver() {
	console.log('👁️ [SPIXN] Setting up zenlink observer');
	
	// 初期チェック
	if (checkZenlinkElement()) {
		console.log('[SPIXN] zenlink element detected on initial check');
		disableSpixnFeatures();
		return;
	}
	
	// 動的監視の設定
	const observer = new MutationObserver(() => {
		if (checkZenlinkElement()) {
			console.log('[SPIXN] zenlink element detected during observation');
			disableSpixnFeatures();
		}
	});
	
	observer.observe(document.body, {
		childList: true,
		subtree: true
	});
	
	window.spixnZenlinkObserver = observer;
	console.log('✅ [SPIXN] zenlink observer setup complete');
}

// グローバルに公開（外部から呼び出し用）
window.ShopifyBuybackProduct = {
	initialize,                    // メイン実行関数（shopId, apiBaseUrlを引数で受け取る）
	getBuybackInformation,        // バイバック情報取得
	setupBuybackIntegration,      // バイバック統合セットアップ
	getShopId,                    // Shop ID取得
	setShopId,                    // Shop ID設定
	getApiBaseUrl,                // API Base URL取得
	setApiBaseUrl,                // API Base URL設定
	checkZenlinkElement,          // zenlink要素チェック
	disableSpixnFeatures,         // SPIXN機能無効化
	setupZenlinkObserver          // zenlink監視設定
};

})();
